module.exports = __webpack_public_path__ + "img/icon_map_63_on_100.b922351c.png";